import { render } from "./AdminWithdrawRequestList.vue?vue&type=template&id=44015359&scoped=true&ts=true&lang=true"
import script from "./AdminWithdrawRequestList.vue?vue&type=script&lang=ts"
export * from "./AdminWithdrawRequestList.vue?vue&type=script&lang=ts"

import "./AdminWithdrawRequestList.vue?vue&type=style&index=0&id=44015359&scoped=true&lang=css"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-44015359"]])

export default __exports__